import { Button, Grid, Typography } from '@mui/material';
import { NavigateFunction, useLocation, useNavigate } from 'react-router-dom';
import { ROUTE_AUTHENTICATION } from '@/app/routes';
import { SuccessIcon } from '@/components/common/SuccessIcon';
import { Theme } from '@mui/material/styles';
import React, { FC, ReactElement } from 'react';

export const RegistrationConfirmSuccess: FC = (): ReactElement => {
  const { state } = useLocation();
  const navigate: NavigateFunction = useNavigate();

  return (
    <Grid container={true} direction={'column'} alignItems={'center'} spacing={4} mt={14} mb={17}>
      <Grid item={true}>
        <Grid container={true} direction={'column'} alignItems={'center'} spacing={2}>
          <Grid item={true}>
            <SuccessIcon />
          </Grid>
          <Grid item={true}>
            <Typography variant={'h2'} textAlign={'center'}>
              {'Вы подтвердили адрес электронной почты'}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item={true}>
        <Button
          color={'primary'}
          variant={'contained'}
          onClick={(): void | Promise<void> => navigate(ROUTE_AUTHENTICATION, { replace: true, state: state })}
          sx={{ minWidth: (theme: Theme): string => theme.spacing(33) }}>
          {'Перейти в личный кабинет'}
        </Button>
      </Grid>
    </Grid>
  );
};
